"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOrderSort = void 0;
var EOrderSort;
(function (EOrderSort) {
    EOrderSort[EOrderSort["NEWEST"] = -1] = "NEWEST";
    EOrderSort[EOrderSort["OLDEST"] = 1] = "OLDEST";
    EOrderSort["DEADLINE_SOONEST"] = "deadline_soonest";
    EOrderSort["DEADLINE_LATEST"] = "deadline_latest";
})(EOrderSort || (exports.EOrderSort = EOrderSort = {}));
